<template>
  <div class="py-1">
    <simple-label
      :id="'phone_number'"
      :label="label"
      :label-info="help"
      :required="required"
    ></simple-label>
    <div class="flex items-center justify-start">
      <span class="pr-1">+</span>
      <input
        placeholder=""
        maxlength="4"
        class="mr-2"
        id="phone_code"
        type="tel"
        name="phone_code"
        v-model="$parent.form.phone_code"
        @change="$parent.form.errors.clear('phone_code')"
        style="-webkit-box-shadow: 0 0 0 50px #fff inset; width: 2.8rem"
        required
      />
      <input
        class=""
        pattern="^[0-9\. \(\)_+-]+$"
        placeholder=""
        id="phone_number"
        type="text"
        name="phone_number"
        v-model="$parent.form.phone_number"
        @change="$parent.form.errors.clear('phone_number')"
        required
      />
    </div>
    <span class="help danger flex justify-between w-full">
      <span
        v-if="$parent.form.errors.has('phone_code')"
        v-text="$parent.form.errors.get('phone_code')"
      ></span>
      <span
        v-if="$parent.form.errors.has('phone_number')"
        v-text="$parent.form.errors.get('phone_number')"
      ></span>
    </span>
  </div>
</template>

<script>
import SimpleLabel from "./SimpleLabel";

export default {
  props: ["label", "help", "required"],
  components: { SimpleLabel },
  mixins: [],
  data: function () {
    return {};
  },
  methods: {},
  computed: {},
  mounted() {},
};
</script>

<style></style>
